<template>
  <div>
    <el-dialog width="40%" :visible.sync="checkedMealTimeBoxState">
      <add-product-dialog :resourceObj="resourceObj" :productObj="productObj" :chenckBudgteObj="chenckBudgteObj" :keyStr="keyStr" 
        @closeDialog="closeDialog" ref="addProductDialog">
        <template v-slot:addProductRightDiv>
          <div class="right">
            <span class="rightTop">住宿城市</span>
            <div v-for="(item,index) in chenckBudgteObj.planDayList" :key="index" class="dayList">
              <el-input v-model="item.cityName" placeholder="请选择最终需要入住的城市名称" size="small"></el-input>
            </div>
          </div>
        </template>
      </add-product-dialog>
    </el-dialog>
  </div>
</template>

<script>
import addProductDialog from './addProductDialog.vue'
import {addProductMixin} from './addProductMixin'
export default {
  components: { addProductDialog },
  mixins:[addProductMixin],
  methods:{
    openDialog(item,item2,chenckBudgteObj,keyStr){
      this.beforeOpenDialog(item,item2,chenckBudgteObj,keyStr)
      this.chenckBudgteObj.planDayList.forEach(element => {
        if(element.cityList.length>0){
          var cityObj = element.cityList[element.cityList.length-1]
          var list = this.resourceObj.customProductAreas.filter(c=>c.pid==cityObj.cityId&&c.type==1)
          if(list.length==0) list = this.resourceObj.customProductAreas.filter(c=>c.pid==cityObj.countryId&&c.type===0)
          if(list.length>0){
            this.$set(element,'cityId',cityObj.cityId)
            this.$set(element,'cityName',cityObj.cityName)
            this.$set(element,'cityNameEn',cityObj.cityNameEn)
          }
        }
      });
    },
  }
}
</script>

<style lang="scss" scoped>
.right{
  text-align: center;
}
.rightTop{
  font-weight: bold;
}
.dayList{
  height: 0.32rem;
  margin-top: 0.1rem;
}
</style>